// Details/Summary height animation
const detailsElements = document.querySelectorAll('details');
        
detailsElements.forEach((details) => {
    const content = details.querySelector('.content');
    
    details.addEventListener('click', (e) => {
        e.preventDefault();
        
        if (details.open) {
            const currentHeight = content.scrollHeight;
            content.style.height = currentHeight + 'px';
            content.offsetHeight;
            content.style.height = '0px';
            
            content.addEventListener('transitionend', function handler() {
                details.removeAttribute('open');
                content.removeEventListener('transitionend', handler);
            });
        } else {
            details.setAttribute('open', '');
            const targetHeight = content.scrollHeight;
            content.style.height = '0px';
            content.offsetHeight;
            content.style.height = targetHeight + 'px';
            
            content.addEventListener('transitionend', function handler() {
                content.style.height = 'auto';
                content.removeEventListener('transitionend', handler);
            });
        }
    });
});